<div
  *ngIf="mensagem && visivel"
  class="toast-mensagem"
  [class.toast-mensagem-erro]="ehErro"
  [class.toast-mensagem-sucesso]="!ehErro"
  role="status"
  aria-live="polite"
>
  <div class="toast-mensagem-conteudo">
    <div class="toast-mensagem-icone">
      <i [class]="ehErro ? 'bi bi-exclamation-lg' : 'bi bi-check-lg'"></i>
    </div>
    <div class="toast-mensagem-texto">
      <strong>{{ titulo }}</strong>
      <span>{{ descricao }}</span>
    </div>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="fechar()"></button>
  </div>
</div>
